<template>    
    <div v-if="isLoading" class="flex justify-center w-full">
        <Spinner />
    </div>

    <!-- <div v-else class="flex flex-col gap-4 w-full"> -->
        <div v-else :class="['flex', direction === 'row' ? 'flex-row' : 'flex-col', 'gap-4', 'w-full']"> 
            <div class="w-full max-w-[360px]">
                <!-- Ввод нового документа -->
                <div v-if="!document && !readOnly">
                    <FloatLabel class="w-full max-w-[360px]" variant="in">
                        <AutoComplete 
                            ref="autoCompletePayerRef" 
                            class="w-full max-w-[360px]" 
                            v-model="currentPayer" 
                            :delay="600" 
                            @item-select="payerChange" 
                            inputId="in_label" 
                            dropdown 
                            optionLabel="name" 
                            :suggestions="payers" 
                            @change="onSearchPayer"  
                            @focus="payerPlaceholder = 'Поиск пользователей...'"
                            @blur="onBlurPayer" 
                            @click="onFocusPayerInput"
                            @dropdown-click="clearCurrentPayer"
                            @complete="onCompletePayerSearch"
                            :placeholder="payerPlaceholder" 
                            emptySearchMessage="Пользователь не найден" 
                            :loading="isLoadingPayers"                                                
                        />
                        <label for="in_label">Плательщик</label>
                    </FloatLabel>
                </div>
                <div v-else>
                    <FloatLabel class="w-full max-w-[360px]" variant="in">
                        <InputText 
                            id="on_label" 
                            :modelValue="currentPayer?.name" 
                            class="w-full max-w-[360px]" 
                            readonly 
                        />                        
                        <label for="in_label">Плательщик</label>
                    </FloatLabel>
                </div>
            </div>
            <div class="w-full max-w-[360px]">
                <div v-if="!document && !readOnly">
                    <FloatLabel class="w-full max-w-[360px]" variant="in">
                        <AutoComplete 
                            ref="autoCompleteRecipientRef" 
                            class="w-full max-w-[360px]" 
                            v-model="currentRecipient" 
                            :delay="600" 
                            @item-select="recipientChange" 
                            inputId="in_label" 
                            dropdown 
                            optionLabel="name" 
                            :suggestions="recipients" 
                            @change="onSearchRecipient"  
                            @focus="recipientPlaceholder = 'Поиск пользователей...'"
                            @blur="onBlurRecipient" 
                            @click="onFocusRecipientInput"
                            @dropdown-click="clearCurrentRecipient"
                            @complete="onCompleteRecipientSearch"
                            :placeholder="recipientPlaceholder" 
                            emptySearchMessage="Пользователь не найден" 
                            :loading="isLoadingRecipients"                                                
                        />
                        <label for="in_label">Получатель</label>
                    </FloatLabel>
                </div>
                <div v-else>
                    <FloatLabel class="w-full max-w-[360px]" variant="in">
                        <InputText 
                            id="on_label" 
                            :modelValue="currentRecipient?.name" 
                            class="w-full max-w-[360px]" 
                            readonly 
                        />                        
                        <label for="in_label">Получатель</label>
                    </FloatLabel>
                </div>
            </div>
            <div class="flex w-full gap-[16px] max-w-[360px]">
                <div class="w-full max-w-[172px]">
                    <FloatLabel class="w-full max-w-[172px]" variant="in">
                        <InputNumber 
                            v-model="amount"  
                            :readonly="document?.readOnly || readOnly"
                            :minFractionDigits="0" 
                            :maxFractionDigits="5" 
                            :min="0"
                            fluid 
                            inputId="in_label" 
                            @input="handleAmountChange"
                            :invalid="!!amountError"
                        />
                        <label for="in_label">Сумма</label> 
                    </FloatLabel>
                    <small v-if="amountError" class="p-error">{{ amountError }}</small>
                </div>
                <div class="w-full max-w-[172px]">
                    <FloatLabel class="w-full max-w-[172px]" variant="in">
                        <template v-if="!document?.readOnly && !readOnly">
                            <Select
                                v-model="currency"
                                optionLabel="name"
                                :options="currencies"
                                class="w-full max-w-[180px]"
                            />
                        </template>
                        <template v-else>                        
                            <InputText :value="currency?.name" class="w-full max-w-[180px] p-filled" readonly/>
                        </template>
                        <label for="in_label">Валюта</label>
                    </FloatLabel>
                </div>                
            </div>
            <div v-if="amount > 0 && referenceContent" class="w-full flex items-bottom gap-2" >
                <i :class="referenceContent.iconClass"></i>
                <h6 class="mb-0">
                {{ referenceContent.text }}
                </h6>
            </div>
            <div class="w-full max-w-[360px]">
                <Textarea 
                    v-model="description"
                    :readonly="document?.readOnly || readOnly" 
                    rows="3" size="small" 
                    placeholder="Описание" 
                    class="w-full max-w-[360px]" 
                    style="resize: none" 
                />    
            </div>
        
            <div class="flex justify-center max-h-[56px] max-w-[360px]">            
                <div v-if="document">
                    <div v-if="!document?.readOnly && !readOnly" class="w-full flex justify-center gap-4">
                        <Button label="Сохранить" icon="pi pi-save" severity="success" class="mr-2" @click="updateTransaction" :disabled="isSubmitting || amountError || !amount" />
                        <Button label="Удалить" icon="pi pi-trash" severity="danger" @click="onDeleteConfirm" :disabled="isSubmitting" />
                    </div>
                </div>
                <div v-else>
                    <Button label="Записать" @click="createTransaction" :disabled="isSubmitting || amountError || !amount" />
                </div>
            </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'; 
import Select from 'primevue/select';
import AutoComplete from 'primevue/autocomplete';
import FloatLabel from 'primevue/floatlabel';
import InputNumber from 'primevue/inputnumber';
import InputText  from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button'; 
import Spinner from '@/components/UI/Spinner.vue';
import { PhysicalPersonsService } from "@/services/physical-persons";
import { CurrenciesService } from "@/services/currencies";
import { TransfersService } from "@/services/transfers";
import { appendAlert } from '@/plugins/alert';
import { isBoolean } from 'util';

export default {
    name: 'TransactionsPage',
    components: {
        AutoComplete,
        FloatLabel, 
        Select,
        Button, 
        Spinner,
        InputNumber,
        InputText,
        Textarea,
    },
    props: {
        setDefaults: {
            type: Boolean,
            default: true
        },
        direction: {
            type: String,
            default: 'col', 
            validator: (val) => ['row', 'col'].includes(val),
        },
        document: {
            type: Object,
            default: null,
        },
        readOnly: {
            type: Boolean,
            default: false
        }        
    },
    data() {
        return {
            currentPayer: null, 
            prevCurrentPayer: null,
            payers: [],
            isLoadingPayers: false, 
            currentRecipient: null,
            prevCurrentRecipient: null,
            recipients: [],
            isLoadingRecipients: false,
            allPhysicalPersonsList: [],
            amount: null,
            amountError: null, 
            currency: null,
            currencies: [],
            description: '',
            isLoading: true, 
            isSubmitting: false,
            payerPlaceholder: '',
            recipientPlaceholder: '',
        }
    },

    computed: {
        ...mapGetters('ui', ['isMobile']),

        referenceContent() {
            return this.getReferenceContent();
        }
    },

    created() {
        this.setUpComponent();
    },    

    methods: {   
        setUpComponent() { 
            this.setOptions();                       
        }, 

        async setOptions() {
            this.isLoading = true; 
            try {
                const { data: physicalPersonResult } =  await PhysicalPersonsService.getPesonsList();
                const { data: currenciesResult } =  await CurrenciesService.getCurrencies();
                this.currencies = currenciesResult;
                this.currency = currenciesResult[0];
                const sortedPhysicalPersonResult = physicalPersonResult?.sort((a, b) => a.name.localeCompare(b.name))
                this.allPhysicalPersonsList = sortedPhysicalPersonResult
                this.payers = sortedPhysicalPersonResult
                this.recipients = sortedPhysicalPersonResult                

                if (this.document) {
                    // Режим редактирования
                    this.currentPayer = sortedPhysicalPersonResult.find(p => p.guid === this.document.sender?.id);
                    this.prevCurrentPayer = this.currentPayer;
                    this.currentRecipient = sortedPhysicalPersonResult.find(p => p.guid === this.document.recipient?.id);
                    this.prevCurrentRecipient = this.currentRecipient;
                    this.amount = this.document.sum;
                    this.description = this.document.description;
                    this.currency = currenciesResult.find(c => c.guid === this.document.currency) || currenciesResult[0];
                } else if (this.setDefaults) {
                    // Режим создания
                    this.currentPayer = sortedPhysicalPersonResult[0];
                    this.prevCurrentPayer = sortedPhysicalPersonResult[0];
                    this.currentRecipient = sortedPhysicalPersonResult[1];
                    this.prevCurrentRecipient = sortedPhysicalPersonResult[1];
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false
            }
        },

        handleAmountChange(event) {
            this.amount = event.value

            if (event.value === null || event.value <= 0) {
                this.amountError = 'Сумма должна быть больше нуля.'
            } else {
                this.amountError = null
            }
        },    

        payerChange(event) {
            this.prevCurrentPayer = event.value;
            this.$refs.autoCompletePayerRef?.hide();
        },

        recipientChange(event) {
            this.prevCurrentRecipient = event.value;
            this.$refs.autoCompleteRecipientRef?.hide();
        },

        onBlurPayer() {
            this.restorePreviousPayer();
            this.payerPlaceholder = "";
        },

        restorePreviousPayer() {
            if (!this.currentPayer && this.prevCurrentPayer) {
                this.currentPayer = this.prevCurrentPayer 
            }
            this.$refs.autoCompletePayerRef?.hide();            
        },

        onBlurRecipient() {
            this.restorePreviousRecipient();
            this.recipientPlaceholder = "";
        },

        restorePreviousRecipient() { 
            if (!this.currentRecipient && this.prevCurrentRecipient) {
                this.currentRecipient = this.prevCurrentRecipient 
            }
            this.$refs.autoCompleteRecipientRef?.hide();           
        },

        clearCurrentPayer() {
            this.currentPayer = null
            this.payers = [...this.allPhysicalPersonsList];
            this.$refs.autoCompletePayerRef?.show();
        },

        clearCurrentRecipient() {
            this.currentRecipient = null
            this.recipients = [...this.allPhysicalPersonsList];
            this.$refs.autoCompleteRecipientRef?.show();
        },

        onFocusPayerInput() {
            this.currentPayer = null;
            this.payers = [...this.allPhysicalPersonsList];
            this.$refs.autoCompletePayerRef?.show();
        },

        onFocusRecipientInput() {
            this.currentRecipient = null;
            this.recipients = [...this.allPhysicalPersonsList];
            this.$refs.autoCompleteRecipientRef?.show();
        },

        onCompletePayerSearch() {
           this.payers = [...this.payers]
        },

        onCompleteRecipientSearch() {
           this.recipients = [...this.recipients]
        },

        async onSearchPayer(event) { 
            if (event?.value?.length >= 3) {
                this.isLoadingPayers = true
                try {            
                    const { data: physicalPersonResult } =  await PhysicalPersonsService.getPesonsList(event.value);
                    this.payers = [...physicalPersonResult.sort((a, b) => a.name.localeCompare(b.name))];
                } catch (e) {                
                    this.error = e.message
                    console.log(e)                
                    return
                } finally {
                    this.isLoadingPayers = false
                }
            } else {
                this.payers = this.allPhysicalPersonsList;
                this.isLoadingPayers = false
            }
        },

        async onSearchRecipient(event) { 
            if (event?.value?.length >= 3) {
                this.isLoadingRecipients = true
                try {            
                    const { data: physicalPersonResult } =  await PhysicalPersonsService.getPesonsList(event.value);
                    this.recipients = [...physicalPersonResult.sort((a, b) => a.name.localeCompare(b.name))];
                } catch (e) {                
                    this.error = e.message
                    console.log(e)                
                    return
                } finally {
                    this.isLoadingRecipients = false
                }
            } else {
                this.recipients = this.allPhysicalPersonsList;
                this.isLoadingRecipients = false
            }
        },

        preparePayload() {                                                
            const params = {                      
                sender: this.currentPayer.guid,
                recipient: this.currentRecipient.guid,
                currency: this.currency.guid,
                sum: this.amount, 
            }                        

            if (this.description !== '') {
                params.description = this.description;
            }

            if (this.document) {
                params.date = this.document.date;
            }

            return params;
        },

        async createTransaction() {  
            this.isSubmitting = true
            try {   
                await TransfersService.send(this.preparePayload());                
                
                this.amount = null
                this.description = ''

                this.$emit('create');
            } catch (e) {                
                this.error = e.message
                console.log(e)                
                return
            } finally {
                this.isSubmitting = false
            } 
        },
        
        async updateTransaction() {  
            this.isSubmitting = true
            try {   
                await TransfersService.update(this.document.guid, this.preparePayload()); 
                this.$emit('update');                               
            } catch (e) {                
                this.error = e.message
                console.log(e)                
                return
            } finally {
                this.isSubmitting = false
            } 
        },
        
        async deleteTransaction() {  
            this.isSubmitting = true
            try {   
                await TransfersService.delete(this.document.guid);    
                
                this.$emit('delete');
            } catch (e) {                
                this.error = e.message
                console.log(e)                
                return
            } finally {
                this.isSubmitting = false
            } 
        },

        onDeleteConfirm() {
            this.$confirm.require({
                message: 'Вы уверены, что хотите удалить документ?',
                header: 'Подтверждение удаления',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Да',
                rejectLabel: 'Нет',
                accept: () => this.deleteTransaction(this.document.guid),
            });
        },

        getReferenceContent() {
            const selectedCurrency = this.currency?.name;
            const rate = this.currencies.find(item => item.name === "USDT")?.rate;
            if (!rate) return null;
            
            switch(selectedCurrency) {
                case 'RUB':
                    const usdt = this.currencies.find(item => item.name === "USDT");
                    if (!usdt) return null;
                    const usdtAmount = (this.amount / rate).toFixed(2);
                    return {
                        iconClass: 'pi pi-dollar icons',
                        text: `${usdt.name} справочно(${rate}): ${usdtAmount}`
                    };
                
                case 'USDT':
                    const rub = this.currencies.find(item => item.name === "RUB");
                    if (!rub) return null;
                    const rubAmount = (this.amount * rate).toFixed(2);
                    return {
                        iconClass: 'pi pi-ruble icons',
                        text: `${rub.name} справочно(${rate}): ${rubAmount}`
                    };
                
                default: return null;
            }
        },

        setPayer(person) {
            const p = this.payers.find(p => p.guid === person.guid);
            if (p) {
                this.currentPayer = p;             
                this.prevCurrentPayer = p;
            }
        },

        setReceiver(person) {
            const p = this.recipients.find(p => p.guid === person.guid);
            if (p) {
                this.currentRecipient = p;
                this.prevCurrentRecipient = p; 
            }
        },        
    }
}

</script>

<style lang="scss" scoped>

.dropdown-buttons {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

@media (max-width: 768px) {
    .dropdown-buttons {
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}

.p-error {
  color: #D32F2F;
}

.icons {
    color: var(--p-primary-color);
}

.pi.pi-ruble::before {
  content: "₽"; 
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  padding-bottom: 4px;
}

</style>